// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ActiveContextState {
  readonly activeCompanyId: string | null;
  readonly activeCompanyName: string | null;
  // Aktif sirketin ana para birimi — form/grid FX cozumlemesi bunu baz alir (cevrilecek hedef PB).
  readonly activeCompanyCurrency: string | null;
  // Aktif sirketin ulkesi (ISO 3166-1 alpha-2). Harita ekranlari acilis gorunumunu buna gore kurar:
  // dagitici hangi ulkede calisiyorsa harita o ulkeyi gosterir, sabit bir ulkeye baglanmaz.
  readonly activeCompanyCountry: string | null;
  readonly activeBranchId: string | null;
  readonly activeBranchName: string | null;
  readonly activePeriodId: string | null;
  readonly activePeriodYear: number | null;
  // Aktif şirketin GİB hesabı durdurulmuş mu (state!=1). Canlı durum — PERSIST EDİLMEZ (bayat kalmasın);
  // header (ActiveContextSelector) her şirket değişiminde günceller, gönderim ekranları okur.
  readonly gibClosed: boolean;
  setCompany: (id: string, name: string, currency?: string | null, country?: string | null) => void;
  setBranch: (id: string, name: string) => void;
  setPeriod: (id: string, year: number) => void;
  setGibClosed: (closed: boolean) => void;
  reset: () => void;
}

export const useActiveContextStore = create<ActiveContextState>()(
  persist(
    (set) => ({
      activeCompanyId: null,
      activeCompanyName: null,
      activeCompanyCurrency: null,
      activeCompanyCountry: null,
      activeBranchId: null,
      activeBranchName: null,
      activePeriodId: null,
      activePeriodYear: null,
      gibClosed: false,
      setCompany: (id, name, currency, country) => set({
        activeCompanyId: id, activeCompanyName: name,
        activeCompanyCurrency: currency ?? null,
        activeCompanyCountry: country ?? null,
        activeBranchId: null, activeBranchName: null,
        activePeriodId: null, activePeriodYear: null,
        gibClosed: false, // şirket değişti → yeni durum sorgulanana kadar engelleme (fail-open)
      }),
      setBranch: (id, name) => set({ activeBranchId: id, activeBranchName: name }),
      setPeriod: (id, year) => set({ activePeriodId: id, activePeriodYear: year }),
      setGibClosed: (closed) => set({ gibClosed: closed }),
      reset: () => set({
        activeCompanyId: null, activeCompanyName: null, activeCompanyCurrency: null,
        activeCompanyCountry: null,
        activeBranchId: null, activeBranchName: null,
        activePeriodId: null, activePeriodYear: null, gibClosed: false,
      }),
    }),
    {
      name: 'elpo_active_context',
      // gibClosed canlı durum — localStorage'a yazma (bayat "durduruldu" ile açılmasın).
      partialize: (s) => ({
        activeCompanyId: s.activeCompanyId, activeCompanyName: s.activeCompanyName,
        activeCompanyCurrency: s.activeCompanyCurrency,
        activeCompanyCountry: s.activeCompanyCountry,
        activeBranchId: s.activeBranchId, activeBranchName: s.activeBranchName,
        activePeriodId: s.activePeriodId, activePeriodYear: s.activePeriodYear,
      }),
    },
  ),
);
